export const dataSlider = [
  {
    /* BAJAR EL 30 */
    id: 1,
    imgUrl: "banner_base.jpeg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "",
    linkToo: "",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    /* BAJAR EL 30 */
    id: 2,
    imgUrl: "BANNER_IEEPC.jpeg",
    alt: "Banner",
    itemActive: "active",
    buttonActive: "",
    url: "https://www.ieepcnl.mx/info/publicaciones/",
    linkToo: "https://www.ieepcnl.mx/info/publicaciones/",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
];
